import { queryOptions } from "@tanstack/react-query";
import { storePageApi } from "./store-page/client";
import type {
  StorePageDraft,
  StorePageRevisionSummary,
} from "./store-page/types";

export type StorePageSnapshot = {
  readonly draft:
    | (Pick<StorePageDraft, "current_revision_id" | "content"> & {
        status?: StorePageDraft["status"];
        first_published_at?: StorePageDraft["first_published_at"];
      })
    | null;
  readonly revisions: StorePageRevisionSummary[];
};

export function storePageQueryOptions({
  slug,
  viewerId,
}: {
  slug: string;
  viewerId: string;
}) {
  return queryOptions({
    queryKey: ["store-page", viewerId, slug, { elevatedPrivileges: false }],
    queryFn: async ({ signal }): Promise<StorePageSnapshot> => {
      const [draft, revisions] = await Promise.all([
        storePageApi.getStorePageDraft({ slug, signal }),
        storePageApi.getStorePageRevisions({ slug, signal }),
      ]);
      return { draft, revisions };
    },
    staleTime: 30_000,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
